import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { NgChartsModule , NgChartsConfiguration } from 'ng2-charts';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClient,HttpEventType, HttpClientModule } from "@angular/common/http";
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrModule } from 'ngx-toastr';
import { TranslateLoader, TranslateModule,TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxLoadingModule } from "ngx-loading";
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TruncatePipe } from "./pipe/truncate.pipe";
import { SafePipe } from "./pipe/safe.pipe";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { NgOtpInputModule } from  'ng-otp-input';
// import { TagInputModule } from 'ngx-chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips'; 
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatStepperModule} from '@angular/material/stepper';
// import { MatButtonModule } from '@angular/material/button';
// import { NgxTagsInputModule } from 'ngx-tags-input';
// import { NgxTagsModule } from "ngx-tag-input";
// import { NgxInputTagModule } from '@ngx-lite/input-tag';
// import { NgxTagsInputBoxModule } from "ngx-tags-input-box";
// import { CanvasJSAngularChartsModule } from '@canvasjs/angular-charts';
// import { ChartAllModule, AccumulationChartAllModule } from '@syncfusion/ej2-angular-charts';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './Components/header/header.component';
import { FooterComponent } from './Components/footer/footer.component';
import { SidebarComponent } from './Components/sidebar/sidebar.component';
import { SignupComponent } from './Auth/signup/signup.component';
import { SigninComponent } from './Auth/signin/signin.component';
import { ForgotpasswordComponent } from './Auth/forgotpassword/forgotpassword.component';
import { ChangepasswordComponent } from './Auth/changepassword/changepassword.component';
import { DashboardComponent } from './Pages/dashboard/dashboard.component';
import { SinglesComponent } from './Pages/singles/singles.component';
import { SearchComponent } from './Pages/search/search.component';
import { FaqComponent } from './Pages/faq/faq.component';
import { ProfileComponent } from './Pages/profile/profile.component';
import { PurchaseComponent } from './Pages/purchase/purchase.component';
import { PartnersComponent } from './Pages/partners/partners.component';
import { AlbumsComponent } from './Pages/albums/albums.component';
import { CreatealbumsComponent } from './Pages/createalbums/createalbums.component';
import { CreatesinglevideopostComponent } from './Pages/createsinglevideopost/createsinglevideopost.component';
import { CreateprogramComponent } from './Pages/createprogram/createprogram.component';
import { FollowersComponent } from './Pages/followers/followers.component';
import { FinancialsComponent } from './Pages/financials/financials.component';
import { VideodetailComponent } from './Pages/videodetail/videodetail.component';
import { AlbumslistComponent } from './Pages/albumslist/albumslist.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BankdetailComponent } from './Pages/bankdetail/bankdetail.component';
import { EditsinglevideopostComponent } from './Pages/editsinglevideopost/editsinglevideopost.component';
import { ProgramsComponent } from './Pages/programs/programs.component';
import { EditProfileComponent } from './Pages/edit-profile/edit-profile.component';
import { VerifymailComponent } from './Auth/verifymail/verifymail.component';
import { VideoUploadComponent } from './Pages/video-upload/video-upload.component';
import { CollebrationDetailComponent } from './Pages/collebration-detail/collebration-detail.component';
import { DemoDashboardComponent } from './Pages/demo-dashboard/demo-dashboard.component';
import { CreatePostComponent } from './Pages/create-post/create-post.component';
import { StaticPageComponent } from './Auth/static-page/static-page.component';
import { PrivacyPolicyComponent } from './Pages/privacy-policy/privacy-policy.component';
import { DeleteAccountComponent } from './Pages/delete-account/delete-account.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    SignupComponent,
    SigninComponent,
    ForgotpasswordComponent,
    DashboardComponent,
    SinglesComponent,
    SearchComponent,
    FaqComponent,
    AlbumsComponent,
    ProfileComponent,
    PurchaseComponent,
    PartnersComponent,
    CreatealbumsComponent,
    CreatesinglevideopostComponent,
    CreateprogramComponent,
    FollowersComponent,
    FinancialsComponent,
    ChangepasswordComponent,
    VideodetailComponent,
    AlbumslistComponent,
    BankdetailComponent,
    EditsinglevideopostComponent,
    ProgramsComponent,
    EditProfileComponent,
    VerifymailComponent,
    VideoUploadComponent,
    SafePipe,
    CollebrationDetailComponent,
    DemoDashboardComponent,
    CreatePostComponent,
    StaticPageComponent,
     PrivacyPolicyComponent,
    DeleteAccountComponent
  ],

  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    NgxSliderModule,
    NgChartsModule.forRoot(),
    DragDropModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    NgxPaginationModule,
    BrowserAnimationsModule,
    ImageCropperModule,
    // TagInputModule,
    MatStepperModule,
    MatChipsModule,
    MatSliderModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    // MatButtonModule,
    GooglePlaceModule,
    ToastrModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgOtpInputModule,  

    // NgxTagsInputBoxModule,
    // NgxTagsInputModule,
    // NgxTagsModule,
    // NgxInputTagModule.forRoot(),
    // CanvasJSAngularChartsModule

    // ChartAllModule, AccumulationChartAllModule,
    
    NgxLoadingModule.forRoot({}),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
